export default __webpack_public_path__ + "static/app-features-1-4ce69032cc6ef4d42a10ee338e89d393.png";